import React, { useEffect, useRef, useState } from "react";
import { Banner } from "../components/Banner";
import {
  CloseIcon,
  CollapseArrow,
  ImgContainer,
  ModuleImg,
  ModuleName,
  ModuleToggle,
  ModuleVideosDiv,
  ModulesContainer,
  SearchDiv,
  SearchInput,
  StyledFontIcon,
  VideoContainer,
  VideoDescription,
  VideoFrame,
  VideoName,
  WatchBtn,
} from "../components/Layout";
import { SearchOutlined, YoutubeOutlined } from "@ant-design/icons";
import { useGetVideosQuery } from "../graphql/generated/hooks";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../common/constants";

import reportingCard from "../assets/images/reportingCard.svg";
import purchaseCard from "../assets/images/purchaseCard.svg";
import accountingCard from "../assets/images/accountingCard.svg";
import forecastingCard from "../assets/images/forecastingCard.svg";
import inventoryCard from "../assets/images/inventoryCard.svg";
import posCard from "../assets/images/posCard.svg";
import defaultCard from "../assets/images/defaultCard.svg";

export default function TrainingPortal() {
  const { data, loading } = useGetVideosQuery();
  const [videos, setVideos] = useState(data?.getVideos);
  const [toggle, setToggle] = useState({});
  const [showVideo, setShowVideo] = useState(false);
  const [videoIndex, setVideoIndex] = useState(-1);
  const videoRef = useRef(null);
  const { t, i18n } = useTranslation();
  useOutsideAlerter(videoRef);

  function toggleFunction(id) {
    setToggle({
      ...toggle,
      [id]: !toggle[id],
    });
  }

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowVideo(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const onSearch = (e) => {
    setVideos(
      data?.getVideos?.filter(
        (rec) =>
          rec.EnglishName.toUpperCase().includes(
            e.target.value.toUpperCase()
          ) ||
          rec.ArabicName?.includes(e.target.value) ||
          rec.module?.toUpperCase().includes(e.target.value.toUpperCase()) ||
          t(rec.module?.toLowerCase() || "")
            .toUpperCase()
            .includes(e.target.value.toUpperCase())
      )
    );
  };

  const modules: string[] = [];
  videos?.forEach((rec) => {
    let module = "";
    rec.module ? (module = rec.module) : (module = "Other");
    const foundModule = modules.find((rec) => rec === module);
    if (!foundModule) modules.push(module);
  });

  const pageDirection =
    i18n.language === SUPPORTED_LANGUAGES.AR ? "rtl" : "ltr";

  useEffect(() => {
    setVideos(data?.getVideos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.getVideos]);
  return (
    <div style={{ direction: pageDirection }}>
      <Banner
        title={t("title.training_portal")}
        text={t("description.training_portal")}
      />
      <SearchDiv>
        <SearchInput
          placeholder={t("label.search")}
          style={{ padding: "10px 10px" }}
          onChange={onSearch}
          suffix={
            <SearchOutlined style={{ color: "#fe6a00", fontSize: "18px" }} />
          }
        />
      </SearchDiv>

      <ModulesContainer>
        {modules?.map((module, i) => {
          return (
            <>
              <ModuleToggle>
                <ModuleName>{t(`module.${module.toLowerCase()}`)}</ModuleName>

                <CollapseArrow>
                  {toggle[i] ? (
                    <>
                      <StyledFontIcon
                        icon={faChevronUp}
                        onClick={() => toggleFunction(i)}
                      />
                    </>
                  ) : (
                    <StyledFontIcon
                      icon={faChevronDown}
                      onClick={() => toggleFunction(i)}
                    />
                  )}
                </CollapseArrow>
              </ModuleToggle>

              {toggle[i] && (
                <ModuleVideosDiv>
                  {videos
                    ?.filter((rec) => rec.module === module)
                    .map((video, j) => {
                      return (
                        <>
                          <VideoContainer>
                            <ImgContainer>
                           {/* <YoutubeOutlined
                                style={{ fontSize: "120px", color: "#fe6a00" }}
                              /> */}
                            {
                              module.toLowerCase() === 'reporting'?
                              <ModuleImg src={reportingCard} alt="" /> :
                              module.toLowerCase() === 'purchase'?
                              <ModuleImg src={purchaseCard} alt="" /> :
                              module.toLowerCase() === 'forecasting'?
                              <ModuleImg src={forecastingCard} alt="" /> :
                              module.toLowerCase() === 'inventory'?
                              <ModuleImg src={inventoryCard} alt="" /> :
                              module.toLowerCase() === 'pos'?
                              <ModuleImg src={posCard} alt="" /> :
                              module.toLowerCase() === 'accounting'?
                              <ModuleImg src={accountingCard} alt="" /> :
                              <ModuleImg src={defaultCard} alt="" /> 
                            }
                            </ImgContainer>
                            <ModuleName style={{ color: "#AAAAB1" }}>
                              {t(module.toLowerCase())}
                            </ModuleName>
                            <VideoDescription>
                              {i18n.language === SUPPORTED_LANGUAGES.AR
                                ? video.ArabicName
                                : video.EnglishName}
                            </VideoDescription>
                            <WatchBtn
                              onClick={() => {
                                setShowVideo(true);
                                setVideoIndex(j);
                              }}
                            >
                              {" "}
                              {t("button.watch")}
                            </WatchBtn>
                          </VideoContainer>
                          {showVideo && j === videoIndex && (
                            <VideoFrame ref={videoRef}>
                              <CloseIcon
                                onClick={() => {
                                  setShowVideo(false);
                                }}
                              />
                              <iframe
                                width="100%"
                                height="100%"
                                src={video.url}
                                title={video.EnglishName}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                              ></iframe>
                            </VideoFrame>
                          )}
                        </>
                      );
                    })}
                </ModuleVideosDiv>
              )}
            </>
          );
        })}
      </ModulesContainer>
    </div>
  );
}
